import get from "lodash.get";
import GlobalFiltersUtils from "./utils";
import GlobalFiltersActionTypes from "./types";

class GlobalFiltersActioner {
  setParameter = (key, value, refresh = true) => {
    return {
      type: GlobalFiltersActionTypes.SET_PARAMETER,
      key,
      value,
      refresh,
    };
  };

  // List of Filters
  setFilters = (value) => {
    return {
      type: GlobalFiltersActionTypes.SET_FILTERS,
      value,
    };
  };

  // selected filters
  setSelectedFilters = (value) => {
    return {
      type: GlobalFiltersActionTypes.SET_SELECTED_FILTERS,
      value,
    };
  };

  setDefaultGlobalFilters = (backofficeSettings) => {
    return (dispatch) => {
      const filters = GlobalFiltersUtils.formatFiltersFromApi(
        get(backofficeSettings, "filters")
      );
      const defaultSelected = filters
        .filter((f) => f.defaultSelected)
        .map((f) => f.value);

      dispatch(this.setFilters(filters));
      dispatch(this.setSelectedFilters(defaultSelected));
    };
  };
}

export default new GlobalFiltersActioner();
